// extracted by mini-css-extract-plugin
export var printerCard = "_bk-1";
export var printerCardConfigured = "_bk-2";
export var printerCardError = "_bk-3";
export var printerCardsContainer = "_bk-0";
export var printerIcon = "_bk-8";
export var printerIconConfigured = "_bk-5";
export var printerIconContainer = "_bk-4";
export var printerIconError = "_bk-6";
export var printerIconUnconfigured = "_bk-7";
export var workstationsTableCard = "_bk-9";